import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Col as VdsCol, Row, Grid } from '../../Grid';
import { viewport, isDesktopResolution, isMobile ,isJointTransactionFlow } from '../../Helpers/index';
import { Title } from '../../Typography/index';

const Col = styled(VdsCol)`
  padding-left: 0px; 
  padding-right: 0px
`;

const MiniCartWrapper = styled.div`
@media (min-width: 1025px) {
margin-top: ${(props) => props.topMargin || 0}px;
margin-bottom:${(props) => props.bottomMargin || 0}px;
}
`;

const MiniCart = ({ cartContent, miniCartComponents, hideHeader = false, showOnlyForDesktopView = true, topMarginStyle, bottomMarginStyle }) => {
  const type = viewport();
  const showMinicartContent = (showOnlyForDesktopView === false) ? true : viewport() === 'desktop' || isDesktopResolution();
  return (
    <>
      {
      showMinicartContent && (
      <MiniCartWrapper className="miniCartWrapper" topMargin={topMarginStyle} bottomMargin={bottomMarginStyle} style={{paddingTop: isMobile() ? '20px' : '0px', visibility: isJointTransactionFlow() ? 'hidden' : 'visible'}}>
        <Grid
          rowGutter="0"
          colSizes={{
            mobile: 4,
            tablet: 12,
            desktop: 12,
          }}
        >
          <Row className="noLeftPad noRightPad">
            {!hideHeader && (
            <Col colSizes={{ mobile: 4, tablet: 12, desktop: 12 }}>
              <Title primitive="h2" size={type !== 'mobile' && type !== 'mfapp' ? 'large' : 'medium'} bold ariaLabel={cartContent?.myCart || 'Order Summary'} taxIndex="0">
                {cartContent?.myCart || 'Order Summary'}
              </Title>
            </Col>
            )}
            <Col colSizes={{ mobile: 4, tablet: 12, desktop: 12 }} className={`${type !== 'mobile' && type !== 'mfapp' ? 'margin32' : 'margin24'} onlyTopMargin`}>{miniCartComponents}</Col>
          </Row>
        </Grid>
      </MiniCartWrapper>
      )
}
    </>
  );
};

MiniCart.propTypes = {
  miniCartComponents: PropTypes.array,
  hideHeader: PropTypes.bool,
  cartContent: PropTypes.any,
  showOnlyForDesktopView: PropTypes.bool,
  topMarginStyle: PropTypes.number,
  bottomMarginStyle: PropTypes.number,
};

export default MiniCart;
